import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "../components/Axios";
import { moveTracks } from "../pages/videos/tracks/tracksModel";

export const fetchCharacters = createAsyncThunk("characters/fetch", async (arg, thunkAPI) => {
  const response = await axios.get("/video_project/" + arg + "/characters");
  thunkAPI.dispatch({ type: "characters/setItems", payload: response.data });
  return response.data;
});

// items plus the lookups other tabs read: name, picture and actor by char_id, and the Summary rows
function rebuild(state, items) {
  state.items = items;
  state.summaries = [];
  state.dic = {};
  state.actor = {};
  for (let i of items) {
    state.dic[i.char_id] = i.char_name;
    state.img[i.char_id] = i.rep_track_id;
    state.actor[i.char_id] = i.char_actor;
    state.summaries.push({
      char_id: i.char_id,
      char_name: i.char_name,
      occurrence_time: i.occurrence_time,
      rep_track_id: i.rep_track_id,
      speech_time: i.speech_time,
      occurences: i.tracks_data.length,
    });
  }
  //add All Characters
  state.dic[-2] = "All Characters";
  state.img[-2] = -1;
  state.summaries.unshift({
    char_id: -2,
    char_name: "All Characters",
    rep_track_id: -1,
  });
}

// handle actions in reducers
export const characters = createSlice({
  name: "characters",
  initialState: {
    loading: "idle",
    items: [],
    dic: {},
    img: {},
    actor: {},
    summaries: [],
    id: null,
  },
  reducers: {
    clear: (state, action) => {
      state.items = [];
      state.dic = {};
      state.img = {};
      state.actor = {};
      state.summaries = [];
      state.id = null;
      return state;
    },
    setItems: (state, action) => {
      state.loading = "idle";
      rebuild(state, action.payload);
    },
    // optimistic updates for the Tracks tab; the server's list replaces them via setItems
    moveTracksLocal: (state, action) => {
      const { trackIds, toCharId } = action.payload;
      rebuild(state, moveTracks(current(state.items), trackIds, toCharId));
    },
    renameLocal: (state, action) => {
      const { charId, name, actor } = action.payload;
      rebuild(
        state,
        current(state.items).map((c) => (c.char_id === charId ? { ...c, char_name: name, char_actor: actor } : c))
      );
    },
    setSummary: (state, action) => {
      state.items[action.payload.index].summary = action.payload.summary;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCharacters.pending, (state, action) => {
      state.loading = "pending";
      state.items = [];
      state.summaries = [];
      state.dic = {};
      state.img = {};
      state.actor = {};
    });
  },
});
